import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'ui-component/Loader';
import { GuardProps } from 'types';

// ==============================|| AUTH GUARD ||============================== //

export default function AuthGuard({ children }: GuardProps) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && !isLoggedIn) {
      navigate('/signin', { replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized || !isLoggedIn) {
    return <Loader />;
  }

  return children;
}
